import './FiSeoPageDialog.scss';
import { FiFurnitureService } from '../fiFurniture/FiFurnitureService';
import { FiToastService } from '../../components/fiToast/FiToastService';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiSeoPageDialog.html'),
    bindings: {

    },
})
export class FiSeoPageDialog {
    static $inject = [
        '$mdDialog',
        '$http',
        'fiFurnitureService',
        'fiToastService',
    ];

  
    constructor(
        private $mdDialog: angular.material.IDialogService,
        private $http: angular.IHttpService,
        private fs: FiFurnitureService,
        private ts: FiToastService,
    ) {
        //
    }

    $onInit() {
        // console.log(this.fs.seoPage);
    }

    close() {
        this.$mdDialog.cancel();
    }

    save() {

        this.$http.post("https://www.fitit.lt/db/edit-seo-page.php", { 

            id: this.fs.seoPage.id,
            title: this.fs.seoPage.title,
            keywords: this.fs.seoPage.keywords,
            description: this.fs.seoPage.description,

        }, { headers: {'Content-Type': 'application/json'} })
        .then(function (response) {
            //
        });

        this.ts.show('Išsaugota');
        this.$mdDialog.cancel();
    }


}